import { handleActions } from 'redux-actions';

import { getLogger } from 'companion-app-components/utils/core';
import { resourceStoreTypes, resourceUpserters } from 'companion-app-components/flux/core';
import { 
  categoryGroupListsReducer as componentCategoryGroupListsReducer,
  CATEGORY_GROUP_LISTS_REDUCER_KEY as REDUCER_KEY, 
} from 'companion-app-components/flux/category-group-lists';
import { 
  CategoryGroupListProps, 
} from 'companion-app-components/flux/category-group-lists/categoryGroupListsTypes';

import * as actions from './categoryGroupListsActions';

const log = getLogger('data/categoryGroupLists/categoryGroupListsReducer.js');

const categoryGroupListsStoreFactory =
  resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<CategoryGroupListProps>();

const categoryGroupListsReducer = handleActions<
resourceStoreTypes.QcsSyncResourceStore<CategoryGroupListProps>,
| ReturnType<typeof actions.createCategoryGroupListsAction>
| ReturnType<typeof actions.createCategoryGroupListsSuccessAction>
| ReturnType<typeof actions.createCategoryGroupListsFailureAction>
>({
  [actions.createCategoryGroupListsAction.type]: (state) => {
    log.log('createCategoryGroupListsAction...');
    return state.merge({ isLoading: true });
  },
  [actions.createCategoryGroupListsSuccessAction.type]: (state, { payload }) => {
    log.log('createCategoryGroupListsSuccessAction...\n', payload);
    return resourceUpserters.upsertResources(state, payload);
  },
  [actions.createCategoryGroupListsFailureAction.type]:
    (state, { payload: error }) => resourceUpserters.completeWithError(state, error),

}, categoryGroupListsStoreFactory());

// chain reducers
export const categoryGroupListReducerChain = (state, action) => componentCategoryGroupListsReducer(
  categoryGroupListsReducer(state, action), 
  action,
);

export const CATEGORY_GROUP_LISTS_REDUCER_KEY = REDUCER_KEY;

export default categoryGroupListReducerChain;
